import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';
import { filter, mergeMap } from 'rxjs';

import { DocsActions } from '../docs/docs.actions';
import { selectActiveProjectId } from '../workspace/workspace.selectors';
import { DesignActions } from './design.actions';
import { compactChatMessages } from './design.models';

const loadDesign$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(DesignActions.load),
      concatLatestFrom(() => store.select(selectActiveProjectId)),
      filter(([, pid]) => !!pid),
      mergeMap(([, pid]) => [DocsActions.loadDoc({ projectId: pid as string, key: 'design.chat' })])
    ),
  { functional: true }
);

const setChatMessages$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(DesignActions.setChatMessages),
      concatLatestFrom(() => store.select(selectActiveProjectId)),
      filter(([, pid]) => !!pid),
      mergeMap(([{ messages }, pid]) => {
        const data = { messages: compactChatMessages(messages) };
        return [
          DocsActions.applyLocalData({ projectId: pid as string, key: 'design.chat', data }),
          DocsActions.saveDoc({ projectId: pid as string, key: 'design.chat', data }),
        ];
      })
    ),
  { functional: true }
);

export const designEffects = { loadDesign$, setChatMessages$ };
